import React, { useState, useCallback } from 'react'
import { CModal, CModalBody, CSpinner } from '@coreui/react'
import MemberDetailsCard from '../components/MemberDetailsCard'
import { get } from '../utils/apiClient'

// Ouvre la fiche profil d'un membre dans une MODALE (même pattern que le feed/PostItem),
// et NON par navigation vers /members/:id (qui ouvre l'annuaire).
//
// Usage :
//   const { openProfile, profileModal } = useProfileModal()
//   <span onClick={openProfile(author)}>…</span>
//   {profileModal}   // à rendre une seule fois dans l'arbre
//
// `openProfile(author)` est inerte si l'auteur est neutralisé RGPD (id null) ou absent.
export default function useProfileModal() {
  const [visible, setVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [member, setMember] = useState(null)

  // isAdmin : pour les actions admin de MemberDetailsCard (UI uniquement ; le back gate).
  const isAdmin = localStorage.getItem('userRole') === 'admin'

  const close = useCallback(() => setVisible(false), [])

  const openProfile = useCallback(
    (author) => async (e) => {
      if (!author?.id) return
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation()
      setVisible(true)
      setLoading(true)
      setMember(null)
      try {
        const data = await get(`/members/${author.id}`)
        setMember(data)
      } catch (error) {
        setMember(null)
      } finally {
        setLoading(false)
      }
    },
    [],
  )

  const profileModal = (
    <CModal visible={visible} onClose={close} size="xl">
      <CModalBody className="p-0">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center p-5">
            <CSpinner color="primary" />
          </div>
        ) : member ? (
          <MemberDetailsCard member={member} isAdmin={isAdmin} onClose={close} />
        ) : (
          <div className="p-4 text-center">
            <p>Impossible de charger le profil.</p>
          </div>
        )}
      </CModalBody>
    </CModal>
  )

  return { openProfile, profileModal }
}
